<template>
    <div class="layout-footer">
        <div @click="handleClick(item)" :class="{ active: item.path === $route.meta.name }" v-for="item in menus">
            <img :src="item.path === $route.meta.name ? item.activeIcon : item.icon" alt=""></img>

            <span>{{ item.title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'layout-footer',
    data() {
        return {
        }
    },
    computed: {
        menus() {
            return [
                {
                    icon: require('../assets/img/layout/icon-home.png'),
                    activeIcon: require('../assets/img/layout/icon-home-active.png'),
                    title: this.$t('menu.home'),
                    path: 'home',
                },
                {
                    icon: require('../assets/img/layout/icon-staking.png'),
                    activeIcon: require('../assets/img/layout/icon-staking-active.png'),
                    title: this.$t('menu.staking'),
                    path: 'staking',
                    active: true
                },
                {
                    icon: require('../assets/img/layout/icon-port.png'),
                    activeIcon: require('../assets/img/layout/icon-port-active.png'),
                    title: this.$t('menu.port'),
                    path: 'port',
                },
                {
                    icon: require('../assets/img/layout/icon-internet.png'),
                    activeIcon: require('../assets/img/layout/icon-internet-active.png'),
                    title: this.$t('menu.internet'),
                    path: 'internet',
                },
                {
                    icon: require('../assets/img/layout/icon-me.png'),
                    activeIcon: require('../assets/img/layout/icon-me-active.png'),
                    title: this.$t('menu.me'),
                    path: 'me',
                },
            ]
        }
    },
    mounted() {

    },
    methods: {
        handleClick(item) {
            if (!item.path) return;
            this.$router.push(item.path)
        }
    },

}
</script>

<style lang="less">
.layout-footer {
    position: fixed;
    height: 88px;
    max-width: 375px;
    display: flex;
    bottom: 0;
    width: 100%;
    background: #000;
    align-items: flex-end;
    padding-bottom: 23px;
    border-radius: 14px 14px 0px 0px;
    z-index: 2;
    >div {
        padding-top: 12px;
        flex: 1;
        // justify-content: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        img {
            width: 24px;
            height: 24px;
            margin-bottom: 4px;
        }

        span {
            color: #757575;
            font-size: 10px;
            line-height: 14px;
        }



        &.active {
            span {
                opacity: 1;
            }
        }
    }
}
</style>